import { render, staticRenderFns } from "./closeVersionDialog.vue?vue&type=template&id=58d2cc6e&scoped=true&"
import script from "./closeVersionDialog.vue?vue&type=script&lang=ts&"
export * from "./closeVersionDialog.vue?vue&type=script&lang=ts&"
import style0 from "./closeVersionDialog.vue?vue&type=style&index=0&id=58d2cc6e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d2cc6e",
  null
  
)

export default component.exports